import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {InputUtils} from "@bounce/shared";
import {BounceAddressDetails, BounceLabel, DEFAULT_ADDRESS} from "@bounce/shared/consumer/constants";
import {FormValidations, NumberList, PhoneNumber, useIsMobile} from "@bounce/shared/consumer/helpers";
import {Divider} from "@mui/material";
import {Colors, Container, Text} from "@bounce/shared/ui";
import {map} from "lodash";
import {LinkHref} from "@bounce/shared/consumer/bounce-ui";
import {defaultLinks} from "~/constants/disclaimers";
import React from "react";

const AccountFooter = () => {
  const isMobile = useIsMobile();
  const {partnerDetails} = usePartnerUi();
  const {address, partnerName, phoneNumber, links} = partnerDetails ?? {};

  const resolvedAddress = address || DEFAULT_ADDRESS;
  const resolvedLinks = links || defaultLinks;

  return (
    <Container sx={{padding: "20px", backgroundColor: Colors.tertiary._200}}>
      <Container
        sx={{
          gap: "20px",
          alignItems: "start",
          bottom: 0,
          ...(!isMobile && {width: "730px"}),
        }}
      >
        {!partnerDetails && (
          <Text variant={"inter600"} size={14} sx={{display: "inline"}}>
            Bounce AI, Inc. is a debt collector{" "}
            <Text size={14} sx={{display: "inline"}}>
              attempting to collect a debt. Any information obtained will be used for that purpose.
            </Text>
          </Text>
        )}
        <Container
          fullWidth
          sx={{
            gap: "2px",
            alignItems: "start",
          }}
        >
          <Text size={14}>
            © 2026 {partnerName ? InputUtils.prettierSnakeCase(partnerName) : BounceLabel} All rights reserved.
          </Text>
          <Text size={14}>{resolvedAddress}</Text>
          {phoneNumber ? (
            <Text size={14}>
              Call us at: &nbsp;
              <PhoneNumber href={`tel:${phoneNumber}`}>
                {FormValidations.convertInternationalIntoUSFormat(phoneNumber)}
              </PhoneNumber>{" "}
              &nbsp;
            </Text>
          ) : (
            <NumberList>
              {map(BounceAddressDetails.phone_numbers, (phone, index) => {
                return (
                  <Text size={14} key={index}>
                    Call us at: &nbsp;
                    <PhoneNumber href={`tel:${phone}`}>
                      {FormValidations.convertInternationalIntoUSFormat(phone)}
                    </PhoneNumber>{" "}
                    &nbsp;
                  </Text>
                );
              })}
            </NumberList>
          )}
        </Container>
        <Divider sx={{height: "1px", width: "100%", borderColor: Colors.grey._300}} />
        <Container
          fullWidth
          row={!isMobile}
          sx={{
            gap: isMobile ? "4px" : "10px",
            alignItems: "start",
          }}
        >
          {Object.entries(resolvedLinks).map(([key, value]) => (
            <LinkHref key={key} text={InputUtils.prettierSnakeCase(key)} size={14} href={value} />
          ))}
        </Container>
      </Container>
    </Container>
  );
};

export default AccountFooter;
